// import React, { useState, useEffect } from "react";
// import { Button, Input, InputNumber, Upload, message, Space } from "antd";
// import { PlusOutlined, EditOutlined } from "@ant-design/icons";
// import imageCompression from 'browser-image-compression';
// import "./variant-form.scss";

// const VariantForm = ({ variants, setVariants, onClose }) => {
  
//   const [currentVariant, setCurrentVariant] = useState({
//     size: "",
//     price: "",
//     images: []
//   });
//   const [editingIndex, setEditingIndex] = useState(null);

//   // Reset form when variants prop changes
//   useEffect(() => {
//     if (editingIndex === null) {
//       setCurrentVariant({
//         size: "",
//         price: "",
//         images: []
//       });
//     }
//   }, [variants, editingIndex]);

//   const handleAddVariant = () => {
//     if (!currentVariant.size || !currentVariant.price) {
//       message.error("O'lcham va narx kiritilishi kerak");
//       return;
//     }

//     if (currentVariant.images.length === 0) {
//       message.error("Hech bo'lmaganda bitta rasm yuklang");
//       return;
//     }

//     const formattedVariant = {
//       ...currentVariant,
//       size: String(currentVariant.size),
//       price: Number(currentVariant.price)
//     };

//     if (editingIndex !== null) {
//       // Update existing variant
//       const updatedVariants = [...variants];
//       updatedVariants[editingIndex] = formattedVariant;
//       setVariants(updatedVariants);
//       setEditingIndex(null); // Reset editing 
//     } else {
//       // Add new variant
//       setVariants([...variants, formattedVariant]);
//     }

//     setCurrentVariant({
//       size: "",
//       price: "",
//       images: [],
//     });
//   };

// // In VariantForm.js, modify the handleEditVariant function:
// const handleEditVariant = (index) => {
//   const variantToEdit = variants[index];
  
//   // Ensure images array exists and has proper structure
//   const images = Array.isArray(variantToEdit.images) 
//     ? variantToEdit.images.map(img => ({
//         ...img,
//         uid: img.uid || img.id || `img-${Math.random().toString(36).substr(2, 9)}`,
//         status: img.status || 'done'
//       }))
//     : [];

//   setCurrentVariant({
//     ...variantToEdit,
//     images: images
//   });
  
//   setEditingIndex(index);
// };
// const handleImageUpload = async (file) => {
//   const isImage = file.type.startsWith('image/');
//   if (!isImage) {
//     message.error('Faqat rasm fayllarini yuklashingiz mumkin!');
//     return false;
//   }

//   try {
//     // Compress the image before adding to state
//     const compressedFile = await imageCompression(file, {
//       maxSizeMB: 2,
//       maxWidthOrHeight: 1200,
//       useWebWorker: true,
//       initialQuality: 0.8
//     });

//     setCurrentVariant(prev => ({
//       ...prev,
//       images: [...prev.images, {
//         uid: file.uid,
//         name: file.name,
//         status: 'done',
//         originFileObj: compressedFile
//       }]
//     }));
//     return false;
//   } catch (error) {
//     console.error("Image compression error:", error);
//     message.error('Rasmni qisqartirishda xatolik yuz berdi');
//     return false;
//   }
// };
//   const handleImageRemove = (file) => {
//     setCurrentVariant(prev => ({
//       ...prev,
//       images: prev.images.filter(img => img.uid !== file.uid)
//     }));
//   };

//   const handleRemoveVariant = (index) => {
//     const newVariants = [...variants];
//     newVariants.splice(index, 1);
//     setVariants(newVariants);
//     if (editingIndex === index) {
//       setEditingIndex(null);
//       setCurrentVariant({
//         size: "",
//         price: "",
//         images: []
//       });
//     } else if (editingIndex > index) {
//       setEditingIndex(editingIndex - 1);
//     }
//   };

//   return (
//     <div className="variant-form">
//       <div className="existing-variants">
//         <h3 style={{marginBottom:"10px"}}>Mavjud variantlar</h3>
//         {variants.length === 0 ? (
//           <p>Variantlar hali qo'shilmagan</p>
//         ) : (
//           variants.map((variant, index) => (
//             <div key={index} className="variant-item">
//               <div style={{marginTop:"14px"}}>
//                 <p>O'lcham: {variant.size}</p>
//                 <p>Narx: {variant.price} so'm</p>
//                 <p>Rasmlar: {variant.images?.length || 0} ta</p>
//               </div>
//               <Space>
//                 <Button 
//                   icon={<EditOutlined />}
//                   onClick={() => handleEditVariant(index)}
//                   size="small"
//                 >
//                   Tahrirlash
//                 </Button>
//                 <Button 
//                   danger 
//                   onClick={() => handleRemoveVariant(index)}
//                   size="small"
//                 >
//                   O'chirish
//                 </Button>
//               </Space>
//             </div>
//           ))
//         )}
//       </div>

//       <div className="new-variant">
//         <h3 style={{marginBottom:"10px"}}>
//           {editingIndex !== null ? "Variantni tahrirlash" : "Yangi variant qo'shish"}
//         </h3>
//         <Input
//           placeholder="O'lcham (masalan, 42.00)"
//           value={currentVariant.size}
//           onChange={(e) => setCurrentVariant(prev => ({
//             ...prev,
//             size: e.target.value
//           }))}
//         />
//         <InputNumber
//           placeholder="Narx (so'mda)"
//           value={currentVariant.price}
//           onChange={(value) => setCurrentVariant(prev => ({
//             ...prev,
//             price: value
//           }))}
//           min={0}
//           step={1000}
//           style={{ width: '100%', margin: '10px 0' }}
//         />
//         <Upload
//           multiple
//           listType="picture-card"
//           fileList={currentVariant.images}
//           beforeUpload={handleImageUpload}
//           onRemove={handleImageRemove}
//           accept="image/*"
//           showUploadList={{
//             showPreviewIcon: false,
//             showRemoveIcon: true
//           }}
//         >
//           {currentVariant.images.length >= 5 ? null : (
//             <div>
//               <PlusOutlined />
//               <div style={{ marginTop: 8 }}>Rasm yuklash</div>
//             </div>
//           )}
//         </Upload>
//         <Button 
//           type="primary" 
//           onClick={handleAddVariant}
//           disabled={!currentVariant.size || !currentVariant.price || currentVariant.images.length === 0}
//           style={{ marginTop: 16 }}
//         >
//           {editingIndex !== null ? "O'zgarishlarni saqlash" : "Variant qo'shish"}
//         </Button>
//         {editingIndex !== null && (
//           <Button 
//             style={{ marginTop: 16, marginLeft: 8 }}
//             onClick={() => {
//               setEditingIndex(null);
//               setCurrentVariant({
//                 size: "",
//                 price: "",
//                 images: []
//               });
//             }}
//           >
//             Bekor qilish
//           </Button>
//         )}
//       </div>

//       <div style={{"display": "flex","gap": "14px"}} className="actions">
//         <Button onClick={onClose}>Bekor qilish</Button>
//         <Button 
//           type="primary" 
//           onClick={onClose}
//           disabled={variants.length === 0}
//         >
//           Variantlarni saqlash
//         </Button>
//       </div>
//     </div>
//   );
// };


// export default VariantForm;


import React, { useState, useEffect } from "react";
import { Button, Input, InputNumber, Upload, message, Space } from "antd";
import { PlusOutlined, EditOutlined } from "@ant-design/icons";
import "./variant-form.scss";

const VariantForm = ({ variants, setVariants, onClose }) => {
  
  const [currentVariant, setCurrentVariant] = useState({
    size: "",
    price: "",
    images: []
  });
  const [editingIndex, setEditingIndex] = useState(null);

  // Reset form when variants prop changes
  useEffect(() => {
    if (editingIndex === null) {
      setCurrentVariant({
        size: "",
        price: "",
        images: []
      });
    }
  }, [variants, editingIndex]);

  const handleAddVariant = () => {
    if (!currentVariant.size || !currentVariant.price) {
      message.error("O'lcham va narx kiritilishi kerak");
      return;
    }

    if (currentVariant.images.length === 0) {
      message.error("Hech bo'lmaganda bitta rasm yuklang");
      return;
    }

    const formattedVariant = {
      ...currentVariant,
      size: String(currentVariant.size),
      price: Number(currentVariant.price)
    };

    if (editingIndex !== null) {
      // Update existing variant
      const updatedVariants = [...variants];
      updatedVariants[editingIndex] = formattedVariant;
      setVariants(updatedVariants);
      setEditingIndex(null); // Reset editing 
    } else {
      // Add new variant
      setVariants([...variants, formattedVariant]);
    }

    setCurrentVariant({
      size: "",
      price: "",
      images: [],
    });
  };

// In VariantForm.js, modify the handleEditVariant function:
const handleEditVariant = (index) => {
  const variantToEdit = variants[index];
  
  // Ensure images array exists and has proper structure
  const images = Array.isArray(variantToEdit.images) 
    ? variantToEdit.images.map(img => ({
        ...img,
        uid: img.uid || img.id || `img-${Math.random().toString(36).substr(2, 9)}`,
        status: img.status || 'done'
      }))
    : [];

  setCurrentVariant({
    ...variantToEdit,
    images: images
  });
  
  setEditingIndex(index);
};
  const handleImageUpload = (file) => {
    const isImage = file.type.startsWith('image/');
    const isLt5MB = file.size / 1024 / 1024 < 30;  // Change from 5 to 30
    
    if (!isImage) {
      message.error('Faqat rasm fayllarini yuklashingiz mumkin!');
      return false;
    }
    
    if (!isLt5MB) {
      message.error('Rasm hajmi 5MB dan kichik bo‘lishi kerak!');
      return false;
    }
    
    setCurrentVariant(prev => ({
      ...prev,
      images: [...prev.images, {
        uid: file.uid,
        name: file.name,
        status: 'done',
        originFileObj: file
      }]
    }));
    return false;
  };

  const handleImageRemove = (file) => {
    setCurrentVariant(prev => ({
      ...prev,
      images: prev.images.filter(img => img.uid !== file.uid)
    }));
  };

  const handleRemoveVariant = (index) => {
    const newVariants = [...variants];
    newVariants.splice(index, 1);
    setVariants(newVariants);
    if (editingIndex === index) {
      setEditingIndex(null);
      setCurrentVariant({
        size: "",
        price: "",
        images: []
      });
    } else if (editingIndex > index) {
      setEditingIndex(editingIndex - 1);
    }
  };

  return (
    <div className="variant-form">
      <div className="existing-variants">
        <h3 style={{marginBottom:"10px"}}>Mavjud variantlar</h3>
        {variants.length === 0 ? (
          <p>Variantlar hali qo'shilmagan</p>
        ) : (
          variants.map((variant, index) => (
            <div key={index} className="variant-item">
              <div style={{marginTop:"14px"}}>
                <p>O'lcham: {variant.size}</p>
                <p>Narx: {variant.price} so'm</p>
                <p>Rasmlar: {variant.images?.length || 0} ta</p>
              </div>
              <Space>
                <Button 
                  icon={<EditOutlined />}
                  onClick={() => handleEditVariant(index)}
                  size="small"
                >
                  Tahrirlash
                </Button>
                <Button 
                  danger 
                  onClick={() => handleRemoveVariant(index)}
                  size="small"
                >
                  O'chirish
                </Button>
              </Space>
            </div>
          ))
        )}
      </div>

      <div className="new-variant">
        <h3 style={{marginBottom:"10px"}}>
          {editingIndex !== null ? "Variantni tahrirlash" : "Yangi variant qo'shish"}
        </h3>
        <Input
          placeholder="O'lcham (masalan, 42.00)"
          value={currentVariant.size}
          onChange={(e) => setCurrentVariant(prev => ({
            ...prev,
            size: e.target.value
          }))}
        />
        <InputNumber
          placeholder="Narx (so'mda)"
          value={currentVariant.price}
          onChange={(value) => setCurrentVariant(prev => ({
            ...prev,
            price: value
          }))}
          min={0}
          step={1000}
          style={{ width: '100%', margin: '10px 0' }}
        />
        <Upload
          multiple
          listType="picture-card"
          fileList={currentVariant.images}
          beforeUpload={handleImageUpload}
          onRemove={handleImageRemove}
          accept="image/*"
          showUploadList={{
            showPreviewIcon: false,
            showRemoveIcon: true
          }}
        >
          {currentVariant.images.length >= 5 ? null : (
            <div>
              <PlusOutlined />
              <div style={{ marginTop: 8 }}>Rasm yuklash</div>
            </div>
          )}
        </Upload>
        <Button 
          type="primary" 
          onClick={handleAddVariant}
          disabled={!currentVariant.size || !currentVariant.price || currentVariant.images.length === 0}
          style={{ marginTop: 16 }}
        >
          {editingIndex !== null ? "O'zgarishlarni saqlash" : "Variant qo'shish"}
        </Button>
        {editingIndex !== null && (
          <Button 
            style={{ marginTop: 16, marginLeft: 8 }}
            onClick={() => {
              setEditingIndex(null);
              setCurrentVariant({
                size: "",
                price: "",
                images: []
              });
            }}
          >
            Bekor qilish
          </Button>
        )}
      </div>

      <div style={{"display": "flex","gap": "14px"}} className="actions">
        <Button onClick={onClose}>Bekor qilish</Button>
        <Button 
          type="primary" 
          onClick={onClose}
          disabled={variants.length === 0}
        >
          Variantlarni saqlash
        </Button>
      </div>
    </div>
  );
};

export default VariantForm;